<template>
  <div class="container mt-5">
    <nav class="pagination" role="navigation" aria-label="pagination">
      <a
        class="pagination-previous"
        @click="movePage(-1)"
        :disabled="currentPage === 1"
        >Previous</a
      >
      <a
        class="pagination-next"
        @click="movePage(1)"
        :disabled="currentPage === totalPages"
        >Next page</a
      >
      <ul class="pagination-list">
        <li v-for="page in visiblePages" :key="page">
          <a
            v-if="page !== '...'"
            :class="[
              'pagination-link',
              page == currentPage ? 'is-current' : '',
            ]"
            :aria-label="`Goto page ${page}`"
            @click="gotoPage(page)"
            >{{ page }}</a
          >
          <span v-else class="pagination-ellipsis">&hellip;</span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: {
    size: {
      default: 10,
    },
    start: {
      default: 1,
    },
  },
  computed: {
    ...mapGetters(["activeTab", "activeTabIndex"]),
    currentPage: function () {
      return this.activeTab.currentPage;
    },
    totalPages: function () {
      return this.activeTab.totalPages;
    },
    visiblePages: function () {
      const total = this.totalPages;
      const current = this.currentPage;
      const maxVisible = 7;

      if (total <= maxVisible) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }

      const pages = [];
      const leftSiblings = 2;
      const rightSiblings = 2;

      // Always show first page
      pages.push(1);

      // Calculate range around current page
      let startPage = Math.max(2, current - leftSiblings);
      let endPage = Math.min(total - 1, current + rightSiblings);

      // Adjust if at start
      if (current <= 3) {
        endPage = Math.min(5, total - 1);
        startPage = 2;
      }

      // Adjust if at end
      if (current >= total - 2) {
        startPage = Math.max(total - 4, 2);
        endPage = total - 1;
      }

      // Add left ellipsis
      if (startPage > 2) {
        pages.push("...");
      }

      // Add middle pages
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Add right ellipsis
      if (endPage < total - 1) {
        pages.push("...");
      }

      // Always show last page
      if (total > 1) {
        pages.push(total);
      }

      return pages;
    },
  },
  methods: {
    ...mapMutations(["SET_CURRENT_PAGE", "SET_PAGE_SIZE"]),
    ...mapActions(["reset", "fetchList"]),
    movePage(direction) {
      let page = this.currentPage;
      if (direction === -1 && page > 1) {
        page--;
      } else if (direction === 1 && page < this.totalPages) {
        page++;
      } else {
        return;
      }

      this.SET_CURRENT_PAGE({
        tabIndex: this.activeTabIndex,
        page,
      });

      this.fetchList();
    },
    gotoPage(page) {
      if (typeof page === "string") return; // Ignore ellipsis clicks

      this.SET_CURRENT_PAGE({
        tabIndex: this.activeTabIndex,
        page: page,
      });

      this.fetchList();
    },
  },
};
</script>

<style></style>
